<div>
  <input type="text" class="form-control" [required]="fg?.controls?.id?.hasValidator(reqValFn) ?? false" (focus)="onFocus()" (blur)="onBlur()" [(ngModel)]="stopModel" (selectItem)="addStop($event.item)"
    [ngbTypeahead]="search" [inputFormatter]="formatter" [resultFormatter]="formatter" [editable]='false' />
</div>
